import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import styles from './theme.module.scss';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tabsAnatomy.keys);

const line = definePartsStyle({
    tab: {
        _selected: {
            color: styles.linkPrimary,
        },

        color: styles.textMidGray,
    },
    tablist: { borderBottom: '2px solid', borderColor: 'transparent' },
});

const answersMain = definePartsStyle({
    root: {
        display: 'flex',
        flex: '1 1',
        height: 'auto',
        minHeight: 'auto',
        overflowY: 'hidden',
    },
    tabpanel: {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        height: '100%',
    },
});

const variants = {
    'answers-main': answersMain,
    line,
};

export const tabsTheme = defineMultiStyleConfig({ variants });
